import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-buraux',
  templateUrl: './buraux.component.html',
  styleUrls: ['./buraux.component.css']
})
export class BurauxComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
